import Box from "@mui/material/Box";
import { selectQuotationForm } from "app/containers/WorkOrder/redux/selector";
import { actions } from "app/containers/WorkOrder/redux/slice";
import { QuotationFormValues } from "app/containers/WorkOrder/types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { INSULATED_BODY_HEIGHT_OPTIONS } from "../../../data";
import { formKey } from "../../../hooks/useQuoteBoxStructure";
import {
  NumberField,
  NumberedSectionTitle,
  SelectField,
} from "../OpenBoxQuotes/FormFields";
import { useStyles } from "../styles";

const insulatedKey = (suffix: string) => formKey(`INSULATED_BOX.${suffix}`);

const Dimensions = () => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const form = useSelector(selectQuotationForm);

  const updateField = (field: keyof QuotationFormValues, value: string) => {
    dispatch(actions.updateQuotationFormField({ field, value }));
  };

  return (
    <Box className={styles.inputCard}>
      <NumberedSectionTitle
        number={1}
        titleKey={insulatedKey("SECTIONS.DIMENSIONS")}
      />
      <Box className={styles.grid3}>
        <NumberField
          labelKey={insulatedKey("FIELDS.BODY_LENGTH")}
          value={form.assembledLength}
          onChange={(value) => updateField("assembledLength", value)}
        />
        <NumberField
          labelKey={insulatedKey("FIELDS.BODY_WIDTH")}
          value={form.assembledWidth}
          onChange={(value) => updateField("assembledWidth", value)}
        />
        <SelectField
          labelKey={insulatedKey("FIELDS.BODY_HEIGHT")}
          value={form.bodyHeightRange}
          options={INSULATED_BODY_HEIGHT_OPTIONS}
          onChange={(value) => updateField("bodyHeightRange", value)}
        />
      </Box>
    </Box>
  );
};

export default Dimensions;
